import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { selectProfile, selectUsers } from 'data/user';
import { UserTypeMap } from 'data/user/constants';
import css from './style.scss';
import SVG from "components/base/SVG";
import userIcon from 'assets/images/account-page/user-icon.png';


const MiscUser = { id: 0, name: 'Miscellaneous User' };

const TeamMemberList = ({ onDeleteClick, users, loading, miscUserEnabled, primaryEnabled, profile, includeIds, excludeIds, placeholder, selfEnabled }) => {
  let members = users.filter(m => (primaryEnabled || m.type !== 'FULL') && (selfEnabled || m.id !== profile.id));
  if (miscUserEnabled) members = members.concat([MiscUser]);
  if (includeIds) members = members.filter(m => includeIds.includes(m.id));
  if (excludeIds) members = members.filter(m => !excludeIds.includes(m.id));

  return (
  
  <div className={css.users}>
    {!members.length ? (
      <div className={css.noUsers}>{loading ? '' : placeholder}</div>
    ) : (
      <div className={css.grid}>
        {members.map(u => (
          <div className={css.card} key={u.id}>
            <div className={css.cardContent}>
              
              <img
                src={u?.logoUrl || userIcon}
                alt="Profile"
                className={css.profileImage}
                onError={(e) => {
                  e.currentTarget.onerror = null; // prevent infinite loop
                  e.currentTarget.src = userIcon;
                }}
              />

              <div className={css.info}>
                <div className={css.name}>{u.name}</div>
                <div className={css.email}>{u.username}</div>
                <div className={css.type}>
                  {u.type && UserTypeMap[u.type].label}
                </div>
              </div>

              
                <button
                  className={css.deleteBtn}
                  onClick={() => onDeleteClick(u)}
                  disabled={loading}
                >
                   <SVG icon="deleteicon" className={css.deleteIcon} />                       
                </button>
            </div>

            {u.expirationDate && (
              <div className={css.expiration}>
                Slot available until{' '}
                {moment(u.expirationDate)
                  .add(1, 'd')
                  .format('MM/DD/yyyy')}
              </div>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);
};

TeamMemberList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  includeIds: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  excludeIds: PropTypes.array,
  editButtonText: PropTypes.string,
  miscUserEnabled: PropTypes.bool,
  iconSize: PropTypes.number,
  primaryEnabled: PropTypes.bool,
  selfEnabled: PropTypes.bool,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  onEditClick: PropTypes.func.isRequired,
  onReplaceClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

TeamMemberList.defaultProps = {
  editButtonText: 'Edit',
  miscUserEnabled: false,
  primaryEnabled: true,
  selfEnabled: true,
  iconSize: 65,
  placeholder: 'No Team Members',
  loading: false,
};

export default connect(state => ({
  profile: selectProfile(state).toJS(),
  users: selectUsers(state).toJS(),
}))(TeamMemberList);
